import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import RegistraionSection from './section-components/registration';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const Registration = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Registetion" />
        <RegistraionSection />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default Registration

